export const dashboard = {
  noAnnouncements: 'No new announcements',
};
